<template>
  <div id="loan-programs-list-page">
    <div class="loan-programs-no-print">
      <breadcrumb :items="breadcrumbs" />
    </div>
    <v-container fluid>
      <div class="d-flex mb-8 loan-programs-no-print">
        <h2 class="font-weight-bolder mb-6">{{ $t('finance.loanPrograms.title') }}</h2>
        <div class="d-flex ml-auto">
          <div class="d-flex mt-1">
            <v-spacer></v-spacer>
            <v-btn color="primary" dark class="mr-2" @click="handleCreateLoanProgram">
              {{ $t('finance.loanPrograms.create') }}
            </v-btn>
          </div>
        </div>
      </div>
      <!-- Data Table Card -->
      <v-card elevation="0" class="px-5 mt-7 loan-programs-print-area">
        <v-card-text>
            <v-row class="loan-programs-grid-row" style="margin-left:-30px; margin-bottom: 20px; margin-top: 15px;">
            <v-col cols="12">
              <v-data-table :headers="tableHeaders" :items="loanPrograms" :items-per-page="options.limit"
                :footer-props="{ 'items-per-page-options': itemsPerPageOptions }" item-key="id" hide-default-footer
                :loading="loading" :options.sync="options" :server-items-length="totalPrograms"
                :loading-text="$t('loadingData')" @click:row="handleRowClick">
                <template v-slot:top>
                  <div v-show="!hideOnPrint" class="d-flex loan-programs-no-print">
                    <!-- Search Field -->
                    <div class="ml-3" style="width: 280px;">
                      <label for="text">&nbsp;</label>
                      <v-text-field prepend-inner-icon="mdi-magnify" outlined :placeholder="$t('Search')" dense
                        v-model="search" @input="searchQuery" class="shrink"></v-text-field>
                    </div>
                    <!-- Bank Dropdown -->
                    <div class="ml-3">
                      <label for="text">{{ $t("finance.loanPrograms.bank") }}</label>
                      <v-select v-model="selectedBank" :items="bankOptions" item-text="name" item-value="value" outlined
                        dense :placeholder="$t('Select')" @change="handleBankChange" style="width: 180px;"
                        class="shrink" clearable></v-select>
                    </div>
                    <!-- Status Dropdown -->
                    <div class="ml-3">
                      <label for="text">{{ $t('finance.loanPrograms.status') }}</label>
                      <v-select v-model="selectedStatus" :items="statusOptions" item-text="name" item-value="value"
                        outlined dense :placeholder="$t('Select')" @change="handleStatusChange" style="width: 180px;"
                        class="shrink" clearable></v-select>
                    </div>
                    <v-spacer></v-spacer>
                    <!-- Pagination Info -->
                    <div class="py-1 title">
                      {{ fromPrograms }} - {{ toPrograms }} {{ $t("of") }} {{ totalPrograms }}
                    </div>
                    <!-- Pagination Controls -->
                    <v-btn class="mx-2" fab small outlined color="primary" :disabled="options.page <= 1"
                      @click="pageChange(false)">
                      <v-icon dark>mdi-chevron-left</v-icon>
                    </v-btn>
                    <v-btn class="mx-2" fab small outlined color="primary" :disabled="options.page >= totalPages"
                      @click="pageChange(true)">
                      <v-icon dark>mdi-chevron-right</v-icon>
                    </v-btn>
                    <!-- Customization Menu -->
                    <v-menu v-model="menu" :close-on-content-click="false" :nudge-width="200" left :min-width="417">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn class="mx-2" fab small outlined color="primary" v-bind="attrs" v-on="on">
                          <v-icon dark>mdi-cog-outline</v-icon>
                        </v-btn>
                      </template>
                      <v-card width="417">
                        <v-list>
                          <v-list-item>
                            <v-list-item-title>{{ $t("customization") }}</v-list-item-title>
                          </v-list-item>
                          <v-divider></v-divider>
                          <div class="pl-3 pt-2 font-weight-normal">
                            {{ $t("recordsPerPage") }}
                          </div>
                          <v-list-item>
                            <v-slider v-model="itemsPerPageSlider" :tick-labels="itemsPerPageOptions" :max="3" step="1"
                              ticks="always" tick-size="4"></v-slider>
                          </v-list-item>
                          <v-divider class="mt-n3"></v-divider>
                        </v-list>
                        <v-card-text>
                          <v-container fluid>
                            <v-row>
                              <v-col class="mt-n9" cols="6" v-for="header in headers" :key="header.value">
                                <v-checkbox v-if="header.text" v-model="selectedHeaders" :label="header.text"
                                  color="primary" :value="header.text" hide-details></v-checkbox>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-card-text>
                        <v-layout justify-center>
                          <v-card-actions class="mb-5">
                            <v-spacer></v-spacer>
                            <v-btn outlined color="primary" @click="resetDefault" width="190">
                              {{ $t("restoreDefault") }}
                            </v-btn>
                            <v-btn color="primary" @click="resetTableStructure" width="190">
                              {{ $t("apply") }}
                            </v-btn>
                          </v-card-actions>
                        </v-layout>
                      </v-card>
                    </v-menu>
                    <!-- Export and Print Buttons -->
                    <!-- <v-tooltip top color="black" max-width="350">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn class="mx-2" fab small outlined color="primary" v-bind="attrs" v-on="on"
                          @click="exportToPDF">
                          <v-icon dark>mdi-download</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ $t("download") }}</span>
                    </v-tooltip>
                    <v-tooltip top color="black" max-width="350">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn class="mx-2" fab small outlined color="primary" v-bind="attrs" v-on="on"
                          @click="printPDF('document')">
                          <v-icon dark>mdi-printer</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ $t("print") }}</span>
                    </v-tooltip> -->
                  </div>
                </template>
                <!-- Program Title Column -->
                <template v-slot:item.programTitle="{ item }">
                    <div class="d-flex align-center">
                      <img
                        :src="item.programLogo"
                        style="width: 40px; height: 40px; border-radius: 8px; object-fit: cover;"
                        :alt="$t('finance.loanPrograms.programLogo')"
                        class="mr-3"
                        v-if="item.programLogo">
                      <div class="d-flex flex-column">
                        <span class="text-body-2 font-weight-medium">{{ item.programTitle }}</span>
                        <!-- <span class="text-caption text--secondary text-truncate" style="max-width: 300px;">{{ item.description }}</span> -->
                      </div>
                    </div>
                  </template>
                  <!-- Bank Column -->
                  <template v-slot:item.bank="{ item }">
                    <div class="d-flex align-center">
                      <img
                        :src="item.bankLogo"
                        style="width: 40px; height: 40px; border-radius: 8px; object-fit: contain;"
                        :alt="$t('finance.banks.bankLogo')"
                        class="mr-3"
                        v-if="item.bankLogo">
                      <span class="text-body-2 font-weight-medium">{{ item.bankName }}</span>
                    </div>
                  </template>
                  <!-- Status Column -->
                  <template v-slot:item.status="{ item }">
                    <v-btn small rounded min-width="120" depressed :class="getStatusClass(item.status)" height="40">
                      {{ getStatusText(item.status) }}
                    </v-btn>
                  </template>
                <template v-slot:footer></template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import loadingMixin from "@/mixins/LoadingMixin";
import download from "@/mixins/DownloadMixin";
import html2pdf from "html2pdf.js";
import printJS from "print-js";
import FinanceService from "@/_services/FinanceService";

export default {
  created() {
    this.loadLoanPrograms();
    this.loadBankOptions();
  },
  async mounted() {
    this.tableHeaders = this.headers;
    this.selectedHeaders = this.allSelectedHeaders;
  },
  computed: {
    totalPages() {
      return parseInt(Math.ceil(this.totalPrograms / this.options.limit));
    },
    filteredPrograms() {
      let programs = [...this.allLoanPrograms];

      if (this.search) {
        const searchLower = this.search.toLowerCase();
        programs = programs.filter(program =>
          (program.programTitle || '').toLowerCase().includes(searchLower) ||
          (program.description || '').toLowerCase().includes(searchLower) ||
          (program.bankName || '').toLowerCase().includes(searchLower)
        );
      }

      if (this.selectedBank) {
        programs = programs.filter(program => program.bankId === this.selectedBank);
      }

      if (this.selectedStatus) {
        programs = programs.filter(program => program.status === this.selectedStatus);
      }

      return programs;
    },
  },
  data() {
    return {
      debounceTimer: null,
      fromPrograms: 0,
      toPrograms: 0,
      search: "",
      selectedBank: "",
      selectedStatus: "",
      loading: false,
      options: {
        limit: 10,
        page: 1,
      },
      headers: [
        {
          text: this.$t("finance.loanPrograms.programTitle"),
          align: "start",
          value: "programTitle",
          class: "black--text",
          sortable: true,
        },
        {
          text: this.$t("finance.loanPrograms.bank"),
          align: "start",
          value: "bank",
          class: "black--text",
          sortable: true,
        },
        {
          text: this.$t("finance.loanPrograms.status"),
          align: "start",
          value: "status",
          class: "black--text",
          sortable: true,
        },
      ],
      allSelectedHeaders: [
        this.$t("finance.loanPrograms.programTitle"),
        this.$t("finance.loanPrograms.bank"),
        this.$t("finance.loanPrograms.status"),
      ],
      menu: false,
      breadcrumbs: [
        {
          text: this.$t("Finance Management"),
          disabled: false,
          href: "/finance-management",
          exact: true,
        },
        {
          text: this.$t("finance.loanPrograms.title"),
          disabled: false,
          href: "/finance-management/loan-programs",
        },
      ],
      allLoanPrograms: [],
      loanPrograms: [],
      totalPrograms: 0,
      itemsPerPageOptions: [5, 10, 25, 50],
      itemsPerPageSlider: 1,
      selectedHeaders: [],
      tableHeaders: [],
      bankOptions: [],
      statusOptions: [
        { name: this.$t("finance.loanPrograms.allStatuses"), value: "" },
        { name: this.$t("finance.loanPrograms.active"), value: "active" },
        { name: this.$t("finance.loanPrograms.inactive"), value: "inactive" },
      ],
    };
  },
  methods: {
    async loadLoanPrograms() {
      this.startLoading();
      try {
        const params = {
          page: this.options.page,
          limit: this.options.limit,
          search: this.search,
          bankId: this.selectedBank,  
          status: this.selectedStatus,
        };
        const response = await FinanceService.getLoanPrograms(params);
        const programsData = response.data?.rows || [];
        this.totalPrograms = response.data?.count || 0;
        this.fromPrograms = this.totalPrograms > 0 ? (this.options.page - 1) * this.options.limit + 1 : 0;
        this.toPrograms = Math.min(this.options.page * this.options.limit, this.totalPrograms);

        this.allLoanPrograms = Array.isArray(programsData) ? programsData.map(program => ({
          id: program.id,
          programLogo: program.programLogo || '',
          programTitle: program.programTitle || this.$t('finance.banks.notAvailable'),
          description: program.description || '',
          bankId: program.bankId,
          bankName: program.bank?.name || this.$t('finance.banks.notAvailable'),
          bankLogo: program.bank?.logo || '',
          status: program.status || this.$t('finance.banks.notAvailable'),
          loanCurrency: program.loanCurrency,
          loanMinAmt: program.loanMinAmt,
          loanMaxAmt: program.loanMaxAmt,
          loanTerm: program.loanTerm,
          loanTermUnit: program.loanTermUnit,
          loanFinancingType: program.loanFinancingType,
          createdAt: program.createdAt,
          updatedAt: program.updatedAt,
        })) : [];

        this.loanPrograms = this.allLoanPrograms;
      } catch (error) {
        console.error('Error fetching loan programs:', error);
        this.allLoanPrograms = [];
        this.loanPrograms = [];
        this.totalPrograms = 0;
        this.fromPrograms = 0;
        this.toPrograms = 0;
      } finally {
        this.stopLoading();
      }
    },
    async loadBankOptions() {
      try {
        const response = await FinanceService.getBanks({});
        const banks = response.data?.rows || [];
        this.bankOptions = Array.isArray(banks)
          ? banks.map(bank => ({ name: bank.name, value: bank.id }))
          : [];
      } catch (error) {
        console.error('Error fetching bank options:', error);
        this.bankOptions = [];
      }
    },
    async resetDefault() {
      this.tableHeaders = this.headers;
      this.selectedHeaders = this.allSelectedHeaders;
      this.options.limit = this.itemsPerPageOptions[this.itemsPerPageSlider];
      this.menu = false;
      this.loadLoanPrograms();
    },
    async resetTableStructure() {
      this.tableHeaders = this.headers.filter((header) =>
        this.selectedHeaders.includes(header.text)
      );
      this.options.limit = this.itemsPerPageOptions[this.itemsPerPageSlider];
      this.loadLoanPrograms();
    },
    handleBankChange() {
      this.options.page = 1;
      this.loadLoanPrograms();
    },
    handleStatusChange() {
      this.options.page = 1;
      this.loadLoanPrograms();
    },
    searchQuery() {
      clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(() => {
        this.options.page = 1;
        this.loadLoanPrograms();
      }, 500);
    },
    async exportToPDF() {
      this.startLoading();
      try {
        const element = document.querySelector(".v-data-table__wrapper");
        let opt = {
          margin: 1,
          filename: "LoanPrograms.pdf",
          image: { type: "jpeg", quality: 0.95 },
          html2canvas: { scale: 2, useCORS: true },
          jsPDF: { unit: "in", format: "a4", orientation: "landscape" },
        };
        await html2pdf().set(opt).from(element).save();
      } catch (error) {
        console.error("Export error:", error);
      } finally {
        this.stopLoading();
      }
    },
    async printPDF() {
      const element = document.querySelector(".v-data-table__wrapper");
      let opt = {
        margin: 1,
        filename: "LoanPrograms.pdf",
        image: { type: "jpeg", quality: 0.95 },
        html2canvas: { scale: 2, useCORS: true },
        jsPDF: { unit: "in", format: "a4", orientation: "landscape" },
      };
      let worker = await html2pdf()
        .set(opt)
        .from(element)
        .toCanvas()
        .outputPdf("blob", "LoanPrograms.pdf");
      let file = new File([worker], "LoanPrograms.pdf", { type: "application/pdf" });
      var pdfUrl = await URL.createObjectURL(file);
      await printJS({ printable: `${pdfUrl}`, type: "pdf", showModal: true });
    },
    pageChange(next) {
      if (next) this.options.page += 1;
      else this.options.page -= 1;
      this.loadLoanPrograms();
    },
    getStatusText(status) {
      switch (status) {
        case 'active':
          return this.$t('finance.loanPrograms.active');
        case 'inactive':
          return this.$t('finance.loanPrograms.inactive');
        default:
          return status || this.$t('finance.banks.notAvailable');
      }
    },
    getStatusClass(status) {
      switch (status) {
        case 'active':
          return 'green-button';
        case 'inactive':
          return 'inactive-button';
        default:
          return 'inactive-button';
      }
    },
    handleCreateLoanProgram() {
      // Navigate to create loan program page
      this.$router.push({ name: "createLoanProgram" });
    },
    handleRowClick(item) {
      this.$router.push({ name: 'loanProgramDetails', params: { id: item.id } });
    },
  },
  mixins: [loadingMixin, download],
};
</script>

<style lang="scss" scoped>
.green-button {
  background-color: #c1ffe7 !important;
  border: 2px solid #00bd73 !important;
  color: #489e16 !important;
}

.inactive-button {
  background-color: #ffffff !important;
  border: 2px solid #000000 !important;
  color: #000000 !important;
}

::v-deep .v-data-table-header span {
  text-transform: uppercase !important;
  color: black;
  font-weight: bold;
}

::v-deep .v-data-table__wrapper tbody tr {
  cursor: pointer;
}

.bank-icon {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: bold;
  font-size: 14px;
}

.bank-initial {
  color: white;
  font-weight: bold;
}
</style>